import Ajv from 'ajv'
// import ajvKeywords from 'ajv-keywords'

export default errorHandler => async (ctx, next) => {
  const ajv = new Ajv({ $data: true, removeAdditional: true, nullable: true, useDefaults: 'empty' })
  ajv.addSchema(ctx.schemaRefs)

  const ajvWithCoerceTypes = new Ajv({
    coerceTypes: true,
    $data: true,
    removeAdditional: true,
    nullable: true,
    useDefaults: 'empty',
  })
  ajvWithCoerceTypes.addSchema(ctx.schemaRefs)

  const check = (schema, value, dataVar, ajvObj) => {
    if (schema) {
      const validator = ajvObj.compile(schema)
      const valid = validator(value)
      if (!valid) {
        const errorText = ajvObj.errorsText(validator.errors, { dataVar })
        ctx.logger.error(errorText)
        throw new Error(errorText)
      }
    } else if (value) {
      ctx.logger.error(`${dataVar} should be undefined, but get `, value)
      throw new Error(`${dataVar} should be undefined`)
    }
  }

  try {
    check(ctx.schema.requestBody, ctx.request.body, 'requestBody', ajv)
    check(ctx.schema.requestHeaders, ctx.request.headers, 'requestHeaders', ajv)
    check(ctx.schema.requestQuery, ctx.request.query, 'requestQuery', ajv)
    check(ctx.schema.requestParams, ctx.request.params, 'routeParams', ajv)
  } catch (e) {
    const message = `${ctx.request.pathname} check failed: ${e.message}`
    const err = new Error(message)
    if (errorHandler) errorHandler(err)
    else throw err
  }

  await next()

  try {
    check(ctx.schema.responseHeaders, ctx.response.headers, 'responseHeaders', ajvWithCoerceTypes)
    check(ctx.schema.responseBody, ctx.responseBody, 'responseBody', ajv)
  } catch (e) {
    const message = `${ctx.request.pathname} check failed: ${e.message}`
    ctx.logger.error(message)
    const err = new Error(message)
    if (errorHandler) errorHandler(err)
    else throw err
  }
}
